export function normalizeEmailForHash(email: string): string {
  return email.trim().toLowerCase();
}

export function normalizePhoneForHash(phone: string): string {
  return phone.replace(/\D/g, '');
}

export async function sha256Hex(value: string): Promise<string> {
  if (typeof globalThis.crypto?.subtle?.digest !== 'function') {
    return value;
  }

  const digest = await globalThis.crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(value),
  );

  return [...new Uint8Array(digest)]
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
}
